export enum MetaTags {
	ROBOTS = 'robots',
	INDEX = 'index',
	NOINDEX = 'noindex',
	CANONICAL = 'canonical',
	PREV = 'prev',
	NEXT = 'next',
	DESCRIPTION = 'description',
	PRERENDER_STATUS_CODE = 'prerender-status-code'
}
